import { useTimerContext } from 'lib/hooks/timer';
import { PartialProps } from 'src/types';

import OptionButton from '../ui/OptionButton';

const ChoicePartial = ({ slotId, withAnswer, content, givenAnswer, onSubmit }: PartialProps) => {
  const { timeIsUp } = useTimerContext();

  return (
    <div className="space-y-4">
      {content?.options?.map((option, index) => (
        <div key={`${slotId}-${option.value}-${index}`}>
          <OptionButton
            option={String.fromCharCode(65 + index)}
            color={
              withAnswer
                ? content.answer === index
                  ? 'green'
                  : givenAnswer?.answer === index
                  ? 'red'
                  : 'dark'
                : givenAnswer?.answer === index
                ? 'orange'
                : 'dark'
            }
            disabled={timeIsUp || withAnswer}
            selected={content.answer === index || givenAnswer?.answer === index}
            onClick={() => onSubmit(index)}
          >
            {option.value}
          </OptionButton>
        </div>
      ))}
    </div>
  );
};

export default ChoicePartial;
